export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7974.594366a2.jpg";